import { createStyles, Group, Paper, Text } from "@mantine/core";
import {
    IconArrowUpRight,
    IconRainbow,
    IconArrowDownRight,
    IconConfetti,
    IconStairsUp,
} from "@tabler/icons";
import { get_lottie_obj, ordinal_suffix_of } from "../common/utils";
import AnalyticsTabs from "./AnalyticsTabs";

const TestAnalyticsRankings = ({
    number = 10,
    diff = 0,
    description = (
        <Text component="p" m={0}>
            Compared with <b>Score</b> of other aspirants.
        </Text>
    ),
}) => {
    return (
        <AnalyticsTabs
            title={"Ranking"}
            // TitleIcon={IconStairsUp}
            AnimateIcon={get_lottie_obj({
                datakey: "ladder",
                width: 60,
                top: -10,
                left: "calc(100% - 45px)",
                position: "absolute",
            })}
            number={number}
            num_suffix={ordinal_suffix_of(number, true)}
            diff={-1 * diff}
            // diffprefix={diff >= 0 ? "+" : "-"}
            diffsuffix=""
            description={description}
            extradescription={
                "Score is calculated internally by comparing your Accuracy, Speed and Overall Marks with other aspirants."
            }
        />
    );
};

export default TestAnalyticsRankings;
